import { RootState } from "@/store/dtm";
import { credentialType } from "@/types/credentialType";
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import dayjs from "dayjs";

export interface credentialState {
    credential: credentialType
}

const initialState: credentialState = {
    credential: {
        email: "",
        password: "",
        meridianCommunication: false,
        accessToken: "",
        refreshToken: "",
        expiration: ""
    }
}


export const credentialSlice = createSlice({
    name: "credential",
    initialState,
    reducers: {
        setEmail: (state, action: PayloadAction<string>) => {
            const email = action.payload;
            state.credential.email = email;
        },
        setPassword: (state, action: PayloadAction<string>) => {
            const password = action.payload;
            state.credential.password = password;
        },
        setMeridianCommunication: (state, action: PayloadAction<boolean>) => {
            state.credential.meridianCommunication = action.payload;
        },
        setAccessToken: (state, action: PayloadAction<string>) => {
            const token = action.payload;
            state.credential.accessToken = token;
        },
        setRefreshToken: (state, action: PayloadAction<string>) => {
            const token = action.payload;
            state.credential.refreshToken = token;
        },
        setTokenExpiration: (state, action: PayloadAction<string>) => {
            const expires = action.payload;
            state.credential.expiration = expires;
        },
        clearCredentialState: (state) => {
            state.credential.email = "";
            state.credential.password = "";
            state.credential.meridianCommunication = false;
            state.credential.accessToken = "";
            state.credential.refreshToken = "";
            state.credential.expiration = "";
        }
    }
});

export const { setEmail, setPassword, setMeridianCommunication, setAccessToken, setRefreshToken, setTokenExpiration, clearCredentialState } = credentialSlice.actions

export const selectCredential = (state: RootState) => state.credential;

export default credentialSlice.reducer


